export default "__VITE_ASSET__Cgw7g_Ou__";